import type { IconNode } from '../types';

/**
 * @name doorbell-intercom
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQuOCA0YTIuOSAyLjkgMCAwIDAtNS42IDBINWMtLjYgMC0xIC40LTEgMXYxNGMwIC42LjQgMSAxIDFoNC4yYTIuOSAyLjkgMCAwIDAgNS42IDBIMTljLjYgMCAxLS40IDEtMVY1YzAtLjYtLjQtMS0xLTFaIiAvPgogIDxwYXRoIGQ9Ik04IDhoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiA4aC4wMSIgLz4KICA8cGF0aCBkPSJNMTYgOGguMDEiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxNCIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/doorbell-intercom
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const doorbellIntercom: IconNode = [
  [
    'path',
    {
      d: 'M14.8 4a2.9 2.9 0 0 0-5.6 0H5c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h4.2a2.9 2.9 0 0 0 5.6 0H19c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1Z',
      key: '1ezwj1',
    },
  ],
  ['path', { d: 'M8 8h.01', key: '1e4136' }],
  ['path', { d: 'M12 8h.01', key: 'e9boi3' }],
  ['path', { d: 'M16 8h.01', key: 'cr5u4v' }],
  ['circle', { cx: '12', cy: '14', r: '2', key: '1vxwhd' }],
];

export default doorbellIntercom;
